// Normalize various timestamp inputs to lightweight-charts seconds-based Time
import { debugWarn } from "@/lib/utils/debug";

export const formatTime = (timestamp: string | number): number => {
  // Helper for numeric normalization
  const normalizeNumber = (n: number): number => {
    // Treat > 10^10 as milliseconds since epoch, else seconds
    if (n > 9999999999) {
      return Math.floor(n / 1000);
    }
    if (n > 0) {
      return Math.floor(n);
    }
    return 0;
  };

  if (typeof timestamp === "number") {
    return normalizeNumber(timestamp);
  }

  // String cases: numeric string or date string
  if (typeof timestamp === "string") {
    const asNum = Number(timestamp);
    if (!Number.isNaN(asNum)) {
      return normalizeNumber(asNum);
    }
    const date = new Date(timestamp);
    if (!Number.isNaN(date.getTime())) {
      return Math.floor(date.getTime() / 1000);
    }
    debugWarn("Invalid date string:", timestamp);
    return 0;
  }

  debugWarn("Invalid timestamp type:", typeof timestamp);
  return 0;
};
